module.exports = "/_next/static/images/Vector_ok-9e07d302d47b70f34ae398c7e31026e7.svg";